/**
 * CSS
 */
import '../css/index.css';

/**
 * JS
 */
import '@babel/polyfill';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import {Router} from 'react-router-dom';
import {routerMiddleware} from 'react-router-redux';
import {createBrowserHistory} from 'history';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import {MuiThemeProvider} from '@material-ui/core';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import appReducers from 'reducers';
import App from 'components';
import KluwellUiTheme from './theme';
import NotificationProvider from 'contexts/notifications';
import I18nProvider from 'contexts/i18n';
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://9794ca1e29c048b99449f7baf8dc3c45@sentry.io/1315581',
  });
}

const history = createBrowserHistory();
const historyMiddleware = routerMiddleware(history);
const middlewares = [thunk, historyMiddleware];
// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger);
// }

const store = createStore(appReducers, applyMiddleware(...middlewares));

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <MuiThemeProvider theme={KluwellUiTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <NotificationProvider>
            <I18nProvider>
              <App />
            </I18nProvider>
          </NotificationProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Router>
  </Provider>,
  document.getElementById('react-root'),
);

if (process.env.NODE_ENV === 'production') {
  const scriptsToAppend = ReactDOMServer.renderToStaticMarkup(
    <React.Fragment>
      <script src="//static.getclicky.com/js" type="text/javascript" />
      <script type="text/javascript" dangerouslySetInnerHTML={{__html: `try{ clicky.init(100941918); }catch(e){}`}} />
      <noscript>
        <p>
          <img alt="Clicky" width="1" height="1" src="//in.getclicky.com/100941918ns.gif" />
        </p>
      </noscript>
      <script
        type="application/javascript"
        dangerouslySetInnerHTML={{
          __html: `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');ga('create', 'UA-76286723-1', 'auto');ga('send', 'pageview');`,
        }}
      />
      <script src="//d2wy8f7a9ursnm.cloudfront.net/bugsnag-3.min.js" data-apikey="8a07e03d1268cfe17d944b40ace3fcb5" />
    </React.Fragment>,
  );
  document.querySelector('body').insertAdjacentHTML('beforeend', scriptsToAppend);
}
